import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientOfferService {

  constructor(private readonly _http: HttpClient) {

  }

  getClientOffer() {
    return this._http.get<any>(`${environment.endPoint}/api/ClientOffer/Get`);
  }

  updateClientOffer(data: any) {
    return this._http.post(`${environment.endPoint}/api/ClientOffer/Update`, data);
  }
  AddClientOffer(data: any) {
    return this._http.post(`${environment.endPoint}/api/ClientOffer/Create`, data);
  }

  sendMailAgainClientOffer(id: any) {
    return this._http.post(`${environment.endPoint}/api/ClientOffer/SendMailAgainClientOffer?id=${id}`, null);
  }
}
